import { ButtonType, DialogFooterButtonsWidget } from '@tableau/widgets';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { DialogFieldParentStyle } from '~src/commonInfra/dialogs/style/DialogStyles';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { MapDispatchToProps } from '~src/commonInfra/utils/ConnectUtils';
import { ExtractEncryptionMode } from '~src/commonInfra/utils/sites/SitePropertyTypes';
import { getCredentialEncryptionKeyRequest } from '~src/settings/security-settings/sections/credential-encryption/actions/GetCredentialEncryptionKeyRequestAction';
import { ISiteAdminSettings, ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';

import { getExtractEncryptionKeyRequest } from '../actions/GetExtractEncryptionKeyRequestAction';
import { ActivateSiteEncryptionKeyRequest, ActivateSiteEncryptionKeyResult } from '../serverApi/requests/ActivateSiteEncryptionKeyRequest';
import { activateSiteEncryptionKey } from '../services/ExtractEncryptionKeyService';
import { updateSiteSettings } from '../services/UpdateSiteSettingsService';
import { getSetEncryptionModeEnforcedRequest } from '../utils/ExtractEncrpytionUtils';


export interface KMSKeyRestoreViewOwnProps {
    closeDialog: CloseAndDismiss;
    externalKeyId: string;
    siteSettings: ISiteSettingsForSiteAdmin;
}

export interface KMSKeyRestoreViewDispatchProps {
    retrieveExtractEncryptionKey: () => void;
    retrieveCredentialEncryptionKey: () => void;
}

export type KMSKeyRestoreViewProps = KMSKeyRestoreViewOwnProps & KMSKeyRestoreViewDispatchProps;


export interface KMSKeyRestoreViewState {
    isRestoringKey: boolean;
}

export class KMSKeyRestoreViewComponent extends React.PureComponent<KMSKeyRestoreViewProps, KMSKeyRestoreViewState> {

    constructor(props: KMSKeyRestoreViewProps) {
        super(props);
        this.state = {
            isRestoringKey: false,
        };
    }


    public render(): JSX.Element {
        return <>
            <div style={DialogFieldParentStyle}>{Messages.extractEncryption_KMSKeyRestoreDialog_Description()}</div>
            <div style={DialogFieldParentStyle}>{Messages.extractEncryption_KMSKeyRestoreDialog_Warning()}</div>
            <ul style={{paddingLeft: '20px'}}>
                <li id="kms-key-restore-terms-1">{Messages.extractEncryption_KMSKeyRestoreDialog_Warning_1()}</li>
                <li id="kms-key-restore-terms-2">{Messages.extractEncryption_KMSKeyRestoreDialog_Warning_2()}</li>
            </ul>
            <div id="kms-key-restore-validation-message">
                {Messages.extractEncryption_KMSKeyRestoreDialog_validation_message()}
            </div>
            <br></br>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        },
                        {
                            buttonType: ButtonType.Primary,
                            showSpinner: this.state.isRestoringKey,
                            children: Messages.extractEncryption_KMSKeyRestoreDialog_Restore_button(),
                            onClick: () => this.restoreKey(),
                            testId: 'restore-button'
                        }
                    ]}
                />
            </div>
        </>;
    }

    private restoreKey() {
        this.setState({isRestoringKey: true}, () => {
            activateSiteEncryptionKey(new ActivateSiteEncryptionKeyRequest({externalKeyId: this.props.externalKeyId}))
            .then((response: ActivateSiteEncryptionKeyResult) => {
                if(response.errors){
                    ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryption_KMSKeyRestoreDialog_FailureToast() });
                } else {
                    ToasterService.instance.pop({ type: ToastType.Success, text: Messages.extractEncryption_KMSKeyRestoreDialog_SuccessToast() });
                    this.updateSiteSettings();
                    this.props.retrieveExtractEncryptionKey();
                    this.props.retrieveCredentialEncryptionKey();
                }
            })
            .catch(() => {
                ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryption_KMSKeyRestoreDialog_FailureToast() });
            }).finally(() => {
                this.setState({isRestoringKey: false});
                this.props.closeDialog.close();
            });
        });
    }

    private updateSiteSettings() {
        if((this.props.siteSettings?.siteAdminSettings as ISiteAdminSettings)?.extractEncryptionMode !== ExtractEncryptionMode.ENFORCED) {
            updateSiteSettings(getSetEncryptionModeEnforcedRequest(this.props.siteSettings));
        }
    }
}

const mapDispatchToProps: MapDispatchToProps<KMSKeyRestoreViewDispatchProps> =
  (dispatch) => bindActionCreators({
    retrieveExtractEncryptionKey: getExtractEncryptionKeyRequest,
    retrieveCredentialEncryptionKey: getCredentialEncryptionKeyRequest
  },
  dispatch);

export const KMSKeyRestoreView: React.ComponentClass<KMSKeyRestoreViewOwnProps> =
  connect(undefined, mapDispatchToProps)(KMSKeyRestoreViewComponent);